import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Dialog,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  IconButton
} from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch, getKeyPathValue, getMonthYear, request, toast } from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';
import { GENDER_DROPDOWN, RECEIPT_MODE } from '../../../../../constants/dropdown';
import CloseIcon from '@mui/icons-material/Close';
import { BloodRequestDetailsForm } from './BloodRequestDetailsForm';

const initialPatientDataObj = {
  data: [],
  loading: false
};


const initialBloodRequestDataObj = {
  data: [],
  loading: false
};

export const BloodRequest = () => {
  const { pathname } = useLocation();
  const componentIDRef = useRef();
  const bloodGroupIDRef = useRef();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [detailList, setDetailList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [indoorRegisterationDataObj, setIndoorRegisterationDataObj] = useState(initialPatientDataObj);
  const [bloodRequestDataObj, setBloodRequestDataObj] = useState(initialBloodRequestDataObj);
  const [openQueryDialog, setOpenQueryDialog] = useState(false);
  const [originalData, setOriginalData] = useState([]);
  const [input, setInput] = useState('');
  const [inputs, setInputs] = useState('');
  const [isFiltered, setIsFiltered] = useState(false);
  const [productStock, setProductStock] = useState([]);
  const [doctorDropdown, setDoctorDropdown] = useState([]);
  const [sponsorDropdown, setSponsorDropdown] = useState([]);
  const [wardDropdown, setWardDropdown] = useState([]);
  const [roomMasterDropdown, setRoomMasterDropdown] = useState([]);
  const [warehouse, setWareHouse] = useState([]);
  const [clickedRow, setClickedRow] = useState([]);
  const [openRequestDetailsDialog, setOpenRequestDetailsDialog] = useState(false);
  const [componentDropdown, setComponentDropdown] = useState([]);
  const [bloodGroupDropdown, setBloodGroupDropdown] = useState([]);
  const [bloodIntakeData, setBloodIntakeData] = useState([]);
  const [donoruseCredit, setDonorUseCredit] = useState([]);
  const[rowSelected,setRowSelected] = useState(false)

  const user = JSON.parse(localStorage.getItem('user'));

  const { getValues } = useForm();
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // location_to: Yup.string().required(' '),
      })
    ),
    defaultValues: {
      date: new Date().toISOString().split('T')[0],
      time: new Date().toLocaleTimeString('en-US', { hour12: false }).slice(0, 5)
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const IPD_TABLE_HEADER = [
    { header: 'Patient Name', accessor: (row) => row?.patient?.name },
    { header: 'Ipd No.', accessor: 'ipd_no' },
    { header: 'Uhid', accessor: 'uhid' }
  ];

  const TABLE_HEADER = [
    { header: 'Req No.', accessor: 'request_no' },
    { header: 'Uhid', accessor: 'uhid' },
    { header: 'Ipd No', accessor: 'ipd_no' },
    {
      header: 'Patient Name',
      accessor: (row) => `${row?.patient?.name}`
    }
  ];

  const getDoctorDropdown = useCallback(async () => {
    const data = await dropdownFetch('doctor');
    if (!selectedRecord && !getValues('consultant')) {
      const [defaultState] = data.filter(({ status }) => status === 'default');
      setValue('consultant', defaultState?._id);
      if (defaultState) {
        setValue('department', defaultState.qualification_details.department);
      }
    }

    setDoctorDropdown(data);
  }, [selectedRecord, getValues, setValue]);

  const getWardDropdown = useCallback(async () => {
    const data = await dropdownFetch('ward');
    setWardDropdown(data);
  }, []);

  const getRoomMasterDropdown = useCallback(async () => {
    const data = await dropdownFetch('room-master');
    setRoomMasterDropdown(data);
  }, []);

  const getWareHouseDropdown = useCallback(async () => {
    const data = await dropdownFetch('warehouse');
    setWareHouse(data);
  }, []);

  const getSponsorDropdown = useCallback(async () => {
    const data = await dropdownFetch('sponsor');
    if (!selectedRecord) {
      const [defaultSponsor] = data.filter(({ status }) => status === 'default');
      setValue('sponsor', defaultSponsor?._id);
    }
    setSponsorDropdown(data);
  }, []);

  useEffect(() => {
    getDoctorDropdown();
    getSponsorDropdown();
    getWardDropdown();
    getRoomMasterDropdown();
    getWareHouseDropdown();
  }, [getDoctorDropdown, getSponsorDropdown, getWardDropdown, getRoomMasterDropdown, getWareHouseDropdown]);

  const getBloodGroupDropdown = useCallback(async () => {
    const data = await dropdownFetch('blood-bank-group');
    setBloodGroupDropdown(data);
  }, []);

  const getComponentDropdown = useCallback(async () => {
    const data = await dropdownFetch('component');
    setComponentDropdown(data);
  }, []);

  useEffect(() => {
    getBloodGroupDropdown();
    getComponentDropdown();
  }, [getBloodGroupDropdown, getComponentDropdown]);

  const formSubmit = async (formValues) => {
    if (detailList.length === 0) {
      toast('Please add the Details First', { variant: 'warning' });
      return;
    }
    setLoading(true);
    const payload = { ...formValues, blood_items: detailList };
    console.log(payload,"HELLLO PAYLoAD")
    let editFlag = false;
    if (selectedRecord && currentAction === 'edit') {
      editFlag = true;
    }
    const response = await request(editFlag ? '/blood-request-edit' : '/blood-request-create', {
      method: editFlag ? 'PUT' : 'POST',
      params: editFlag ? selectedRecord._id : null,
      body: {
        ...payload,
        createdBy: user.name,
        updatedBy: editFlag ? user.name : '',
        organisation
      }
    });
    if (!response?.success) {
      toast(`${response?.message}`, { variant: 'warning' });
      return;
    }
    if (response?.success) {
      toast(`Successfully ${editFlag ? 'edited' : 'created'} Blood Intake`, { variant: 'success' });
      setSelectedRecord(response.data);
      setCurrentAction();
      setDetailList([]);
      fetchIpdPatient();
      reset();
    } else {
      toast(`Failed to ${editFlag ? 'edit' : 'create'} Blood Intake`, { variant: 'error' });
    }
    setLoading(false);
  };

  const handleRowDelete = (row) => {
    setDetailList((prev) => prev.filter((data) => data.serial_no !== row));
    setBloodIntakeData((prev) => prev.filter((data) => data.serialNo !== row))
  };

  useEffect(() => {
    if (productStock && productStock.length > 0) {
      setOriginalData(productStock);
      setIsFiltered(false);
    }
  }, [productStock]);

  const calculateAge = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDifference = today.getMonth() - birthDate.getMonth();
    if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const handleRowClick = (row) => {
    setClickedRow(row);
    setRowSelected(true);
    setValue('patient_name', row?.patient?.name);
    setValue('uhid', row?.uhid);
    setValue('ipd_no', row?.ipd_no);
    setValue('consultant', row?.indoorregisterations?.consultant_detail?.doctor);
    setValue('gender', row?.patient?.gender);
    setValue('age', calculateAge(row?.patient?.dob));
    setValue('room', row?.indoorregisterations?.consultant_detail?.room);
    setValue('ward', row?.indoorregisterations?.consultant_detail?.roomDetails?.ward);
    setValue('bed_no', row?.indoorregisterations?.consultant_detail?.bed_no);
    setValue('sponsor', row?.patient?.sponsor);
    setValue('requested_no', row?.requested_no);
    setValue('component', row?.blood_items[0]?.component);
    componentIDRef.current = row?.blood_items[0]?.component;
    setValue('blood_group', row?.blood_items[0]?.blood_group);
    bloodGroupIDRef.current = row?.blood_items[0]?.blood_group;
    setValue('quantity', row?.blood_items[0]?.quantity);
  };


  const fetchIpdPatient = async () => {
    const lowercasedInput = input.toLowerCase().trim();
    setIndoorRegisterationDataObj({ loading: true });
    const response = await request('/nurse-blood-requested-list', { method: 'GET', query: { name: lowercasedInput } });
    if (response.success) {
      setIndoorRegisterationDataObj({ loading: false, data: response?.data });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setIndoorRegisterationDataObj({ loading: false });
    }
  };

  useEffect(() => {
    fetchIpdPatient();
  }, [input]);

  const ITEM_DETAIL_HEADER = [
    {
      header: 'Blood Group',
      accessor: (row) => row.blood_group_name
    },
    {
      header: 'Component',
      accessor: (row) => row.component_name
    },
    {
      header: 'Exp Date',
      accessor: (row) => getMonthYear(row.exp_date)
    },
    {
      header: 'Batch No',
      accessor: (row) => row.batch_no
    },
    {
      header: 'Serial No',
      accessor: (row) => row.serial_no
    },
    {
      header: 'Quantity',
      accessor: 'quantity'
    },
    {
      header: 'Rate',
      accessor: 'rate'
    },
    {
      header: 'Donor Discount',
      accessor: (row) => row?.donor_disc || 0
    },
    {
      header: 'Amount',
      accessor: (row) => (row?.amount === 0 ? 0 : row?.amount)
    }
  ];

  const handleQueryWindow = async () => {
    setOpenQueryDialog(true);
    setBloodRequestDataObj({ loading: true });
    const response = await request(`/blood-request-list`, { method: 'GET', query: { limit: 10 } });
    if (response?.success) {
      const sortedData = response.data.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
      setBloodRequestDataObj({ loading: false, data: sortedData });
    } else {
      toast('Error in fetching data', { variant: 'error' });
      setBloodRequestDataObj({ loading: false });
    }
  };

  const handleSearchData = async () => {
    const lowercasedInput = inputs.toLowerCase().trim();
    setBloodRequestDataObj({ loading: true, data: [] });
    try {
      const response = await request('/blood-request-list', {
        method: 'GET',
        query: { name: lowercasedInput, limit: 10 }
      });
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setBloodRequestDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setBloodRequestDataObj({ loading: false, data: [] });
      }
    } catch (error) {
      console.error('Error during search:', error);
      toast('Error during search', { variant: 'error' });
      setBloodRequestDataObj({ loading: false, data: [] });
    }
  };
  useEffect(() => {
    handleSearchData(input);
  }, [inputs]);

  const handleChanges = (e) => {
    setInputs(e.target.value);
  };

  const handleChange = (e) => {
    setInput(e.target.value);
  };

  const onDetailAddHandler = (data) => {
    toast('Details Added Successfully', { variant: 'success' });
    const quantity = data.quantity;
    const componentId = data.component;
    const bloodGroupId = data.blood_group;
    const componentName = componentDropdown.find(({ _id }) => _id === data.component)?.component;
    const bloodGroupName = bloodGroupDropdown.find(({ _id }) => _id === data.blood_group)?.group;
    setDetailList((prev) => [
      ...prev,
      {
        ...data,
        component_name: componentName,
        blood_group_name: bloodGroupName
      }
    ]);
    const donorusedCredit = {
      serialNo: data?.serial_no
    };

    setBloodIntakeData((prevState) => {
      return [...prevState, donorusedCredit];
    });
    setOpenRequestDetailsDialog(false);
  };

  const handleCancelRecord = async () => {
    setLoading(true);
    const response = await request('/nurse-blood-request-status-cancel', {
      method: 'PUT',
      params: clickedRow?._id
    });
    if (response?.success) {
      toast('Successfully cancel Blood Request Cancelled', { variant: 'success' });
      setSelectedRecord();
      fetchIpdPatient();
    } else {
      toast('Failed to cancel Blood Request Cancelled', { variant: 'error' });
    }
    setLoading(false);
  };

  const handleInputChange = (e, rowId, header) => {
    const { value } = e.target;
    const updateRows = (rows) =>
      rows.map((row) => {
        if (row._id === rowId) {
          const updatedRow = {
            ...row,
            [header]: value
          };
          if (header === 'Rate' || header === 'Quantity') {
            const rate = parseFloat(updatedRow.Rate) || 0;
            const quantity = parseFloat(updatedRow.quantity) || 0;
            updatedRow.amount = (rate * quantity).toFixed(2) || 0;
          }
          return updatedRow;
        }
        return row;
      });

    setDetailList(updateRows);
  };

  useEffect(() => {
    let total_amount = 0;
    let bill_amount = 0;
    let total_amt = 0;
    let disc_amt = 0;
    let net_amt = 0;
    let gst_amt = 0;
    detailList.forEach((detail) => {
      const amount = parseFloat(detail.amount);
      bill_amount += amount;
      total_amount += amount;
      total_amt += amount;
    });
    const roundedNetAmt = Math.round(net_amt);
    const roundOff = parseFloat((net_amt - roundedNetAmt).toFixed(2));
    setValue(
      'total_qty',
      detailList.reduce((acc, curr) => acc + curr.quantity, 0)
    );
    setValue('total_amt', total_amt || 0);
    setValue('bill_amount', bill_amount || 0);
    setValue('disc_amt', disc_amt || 0);
    setValue('gst_amt', gst_amt || 0);
    setValue('net_amt', roundedNetAmt || 0);
    setValue('round_off', Math.abs(roundOff) || 0);
  }, [detailList, setValue]);

  const recAmt1Watch = watch('recpt_1');
  const recAmt2Watch = watch('recpt_2');
  const netAmtWatch = watch('total_amt');
  const payMode = watch('pay_mode');
  useEffect(() => {
    const total_recpt = +recAmt1Watch + +recAmt2Watch;
    let balanceAmt = netAmtWatch - total_recpt;

    if (payMode === 'CASH') {
      setValue('recpt_1', netAmtWatch);
      setValue('recpt_2', 0);
      setValue('balance', 0);
    } else if (['Bank', 'UPI', 'Paytm', 'RTGS/NEFT/Cheque', 'Credit Card', 'Debit Card'].includes(payMode)) {
      setValue('recpt_1', 0);
      setValue('recpt_2', netAmtWatch);
      setValue('balance', 0);
    } else if (payMode === 'Credit') {
      setValue('recpt_1', 0);
      setValue('recpt_2', 0);
      setValue('balance', balanceAmt);
    } else {
      setValue('balance', balanceAmt);
    }
  }, [netAmtWatch, recAmt1Watch, recAmt2Watch, payMode, setValue]);

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 2,
            p: 0.2,
            border: '1px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                pb: 0.5,
                mb: 3,
                borderBottom: '1px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Issue Blood
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={`${lastPathSegment}Write`}
                  variant="contained"
                  disabled={['edit', 'new'].includes(currentAction)}
                  onClick={() => {
                    setSelectedRecord();
                    setCurrentAction('new');
                    setDetailList([]);
                    reset();
                  }}
                >
                  New
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Update`}
                  variant="contained"
                  disabled={['new', 'edit'].includes(currentAction) || !selectedRecord}
                  onClick={() => setCurrentAction('edit')}
                >
                  Edit
                </CustomButtonn>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                  disabled={!['edit', 'new'].includes(currentAction) || loading}
                >
                  Save
                </CustomButtonn>
                <CustomButtonn
                  id={'Cancel'}
                  variant="contained"
                  // disabled={!selectedRecord || currentAction}
                  onClick={() => {
                    setCurrentAction();
                    handleCancelRecord();
                  }}
                >
                  Cancel
                </CustomButtonn>
                <CustomButtonn
                  id={`isSuperAdmin`}
                  variant="contained"
                  disabled={!selectedRecord || ['new', 'edit'].includes(currentAction) || loading}
                  // onClick={handleDeleteRecord}
                >
                  Delete
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Read`}
                  variant="contained"
                  onClick={handleQueryWindow}
                  disabled={['new', 'edit'].includes(currentAction)}
                >
                  Query
                </CustomButtonn>
                <CustomButtonn
                  id={`${lastPathSegment}Print`}
                  variant="contained"
                  onClick={() => window.open(`/print${pathname}?refId=${selectedRecord._id}`, '_blank')}
                  disabled={!selectedRecord || currentAction}
                >
                  Print
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Grid
              container
              spacing={1}
              sx={{
                boxShadow: '0px 0px 10px 3px #0099ff',
                borderRadius: '10px',
                padding: '10px',
                height: '65vh',
                border: '1px solid grey'
              }}
            >
              <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Grid item sx={{ display: 'flex', flexDirection: 'column', minHeight: '30rem', marginTop: '1%' }}>
                  <Stack direction="row" spacing={2} alignItems="center" justifyContent="center">
                    <MuiTextField
                      sx={{
                        width: '100%',
                        '& .MuiOutlinedInput-root': {
                          padding: '0',
                          fontSize: '14px',
                          fontWeight: '700'
                        },
                        '& .MuiOutlinedInput-input': {
                          padding: '8px 14px'
                        }
                      }}
                      label="Search Blood Request"
                      variant="outlined"
                      value={input}
                      onChange={handleChange}
                    />
                  </Stack>
                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)', minHeight: '35rem' }}
                      data={['new', 'edit'].includes(currentAction) && indoorRegisterationDataObj?.data || []}
                      columns={IPD_TABLE_HEADER}
                      size="small"
                      onRowClick={(row) => {
                        handleRowClick(row);
                      }}
                    />
                </Grid>
              </Grid>

              <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                <Stack
                  sx={{ border: '1px solid rgba(0,0,0,0.27)', padding: '5px', borderRadius: '5px' }}
                  spacing={0.5}
                  direction="row"
                >
                  <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Sponsor
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="sponsor"
                        placeholder="Select Sponsor"
                        menus={sponsorDropdown}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Room/Bed</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.4 }}
                        name="room"
                        menus={roomMasterDropdown
                          .filter((data) => data.ward === watch('ward'))
                          .map((data) => ({ ...data, name: data.room_no }))}
                        onChange={() => {
                          setValue('bed_no', '');
                        }}
                        placeholder="Select Room"
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="bed_no"
                        placeholder="Bed No."
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Pay Mode
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        menus={RECEIPT_MODE}
                        name="pay_mode"
                        placeholder="Select Pay Mode"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Quantity
                      </Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="quantity"
                        placeholder="Quantity"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Remarks
                      </Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.8 }}
                        name="remarks"
                        placeholder="Remarks"
                      />
                    </Stack>
                  </Grid>
                  <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Req No.
                      </Typography>
                      <TextField
                        disabled
                        sx={{
                          flex: 0.8,
                          border: currentAction ? '0.5px solid red' : '',
                          backgroundColor: currentAction ? '#B3E5FC' : ''
                        }}
                        name="req_no"
                        placeholder="Req No."
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Gender/Age
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.4 }}
                        name="gender"
                        placeholder="Select Gender"
                        menus={GENDER_DROPDOWN}
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="age"
                        placeholder="Age"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Ward
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="ward"
                        placeholder="Select Ward"
                        onChange={() => {
                          setValue('room', '');
                          setValue('bed_no', '');
                        }}
                        menus={wardDropdown}
                      />
                    </Stack>

                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1rem', fontSize: '1.2rem' }}>
                        Component
                      </Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="component"
                        placeholder="Select Component"
                        menus={componentDropdown.map((data) => ({ ...data, name: data?.component }))}
                      />
                    </Stack>

                    {/* <Stack spacing={0.2} direction="row" alignItems="center">
                      <Button sx={{ fontWeight: 700, fontSize: '0.7rem', }} variant="contained">Show Alternate Medicine</Button>
                    </Stack> */}
                  </Grid>
                  <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Date/Time</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{
                          flex: 0.4,
                          border: currentAction ? '0.5px solid red' : '',
                          backgroundColor: currentAction ? '#B3E5FC' : ''
                        }}
                        name="date"
                        type="date"
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{
                          flex: 0.4,
                          border: currentAction ? '0.5px solid red' : '',
                          backgroundColor: currentAction ? '#B3E5FC' : ''
                        }}
                        name="time"
                        type="time"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Ipd/Uhid No.</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="ipd_no"
                        placeholder="Ipd No."
                      />
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="uhid"
                        placeholder="Uhid"
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Consultant</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="consultant"
                        placeholder="Select Consultant"
                        menus={doctorDropdown}
                      />
                    </Stack>
                    <Stack spacing={0.5} direction="row" alignItems="center">
                      <Typography sx={{ flex: 0.4, fontWeight: 700, fontSize: '1.2rem' }}>Blood Group</Typography>
                      <SelectTag
                        disabled={!['new', 'edit'].includes(currentAction)}
                        formControlSX={{ flex: 0.8 }}
                        name="blood_group"
                        placeholder="Select Blood Group"
                        menus={bloodGroupDropdown.map((data) => ({ ...data, name: data.group }))}
                      />
                    </Stack>
                  </Grid>
                </Stack>
                <Typography
                  onClick={() => {
                    if (['new', 'edit'].includes(currentAction)) {
                      setOpenRequestDetailsDialog(true);
                    }
                  }}
                  sx={{
                    fontWeight: 700,
                    fontSize: '1.2rem',
                    color: ['new', 'edit'].includes(currentAction) ? 'blue' : 'grey',
                    cursor: ['new', 'edit'].includes(currentAction) ? 'pointer' : 'not-allowed'
                  }}
                >
                  Add Details
                </Typography>

                <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3, height: 'auto' }}>
                  <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'row', gap: 0.3, height: 'auto' }}>
                    <Table
                      containerSX={{ flex: 1, border: '1px solid rgba(0,0,0,0.27)' }}
                      data={detailList.map((data) => ({ ...data, _id: data?.serial_no }))}
                      columns={ITEM_DETAIL_HEADER}
                      size="small"
                      showDeleteAction={true}
                      onDeleteHandler={handleRowDelete}
                      showInputField={true}
                      handleInputChange={handleInputChange}
                    />
                  </Grid>

                  <Stack direction="row" spacing={0.5} alignItems="center" marginTop={'4%'}>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Total Amt.</Typography>
                      <TextField sx={{ width: '100%' }} name="total_amt" disabled />
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>1. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_1" disabled={payMode==="Credit" }/>
                    </Stack>

                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>2. Recpt.</Typography>
                      <TextField sx={{ width: '100%' }} name="recpt_2"  disabled={payMode ==="CASH" || payMode==="Credit" }/>
                    </Stack>
                    <Stack spacing={0.5} direction="column" alignItems="center" sx={{ flex: 1 }}>
                      <Typography sx={{ fontWeight: 700, fontSize: '1.2rem' }}>Balance</Typography>
                      <TextField disabled sx={{ width: '100%' }} name="balance" />
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </FormProvider>
        </Container>
      </Paper>
      <Dialog
        open={openQueryDialog}
        onClose={() => setOpenQueryDialog(false)}
        PaperProps={{ sx: { width: '80%', p: 2 } }}
        maxWidth="xl"
        scroll="body"
      >
        <Stack
          padding={0}
          direction="row"
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
          borderBottom="1px solid"
          borderColor="grey.300"
        >
          <Typography variant="h4" fontWeight="bold">
            Blood Request Query Window
          </Typography>
          <IconButton onClick={() => setOpenQueryDialog(false)}>
            <CloseIcon color="error" fontSize="large" />
          </IconButton>
        </Stack>
        <Stack>
          <MuiTextField
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-root': {
                padding: '0'
              },
              '& .MuiOutlinedInput-input': {
                padding: '8px 14px'
              }
            }}
            label="Search Blood Requests"
            variant="outlined"
            value={inputs}
            onChange={handleChanges}
            InputProps={{
              style: {
                fontSize: '12px',
                fontWeight: 600
              }
            }}
          />
        </Stack>
        <Table
          sx={{ mt: 0.5 }}
          columns={TABLE_HEADER}
          data={bloodRequestDataObj?.data || []}
          loading={bloodRequestDataObj.loading}
          onRowClick={(row) => {
            setSelectedRecord(row);
            setValue('request_no', row?.requested_no);
            setValue('req_no', row?.request_no);
            setValue('gender', row?.patient?.gender);
            setValue('age', calculateAge(row?.patient?.dob));
            setValue('ipd_no', row?.ipd_no);
            setValue('uhid', row?.uhid);
            setValue('bed_no', row?.indoorregisterations?.consultant_detail?.bed_no);
            setValue('room', row?.indoorregisterations?.consultant_detail?.room);
            setValue('ward', row?.indoorregisterations?.consultant_detail?.roomDetails?.ward);
            setValue('consultant', row?.indoorregisterations?.consultant_detail?.doctor);
            setValue('remarks', row?.remarks);
            setDetailList(row?.blood_items);
            setOpenQueryDialog(false);
          }}
        />
      </Dialog>

      <Dialog
        open={openRequestDetailsDialog}
        onClose={() => setOpenRequestDetailsDialog(false)}
        PaperProps={{ sx: { width: '50%', p: 2, height: '70vh' } }}
        maxWidth="xl"
        scroll="body"
      >
        <BloodRequestDetailsForm
          onClose={() => setOpenRequestDetailsDialog(false)}
          componentDropdown={componentDropdown}
          bloodGroupDropdown={bloodGroupDropdown}
          onAdd={onDetailAddHandler}
          bloodGroupsId={bloodGroupIDRef.current}
          componentsId={componentIDRef.current}
          setBloodIntakeData={setBloodIntakeData}
          bloodIntakeData={bloodIntakeData}
          donoruseCredit={donoruseCredit}
          setDonorUseCredit={setDonorUseCredit}
          rowSelected={rowSelected}
        />
      </Dialog>
    </>
  );
};
